<template>

  <div>

    <ChecklistChangeMapDialog
        v-if="modalChangeMapShow"
        :checklist-id="foreignKey"
        :enterprise-id="enterpriseId"
        :business-type-survey="businessTypeSurvey"
        :status-checklist="statusChecklist"
        @onClose="getList"/>

    <ChecklistEnvironmentItemDialog
        v-if="modalEnvironmentItemShow"
        :checklist-environment-id="modalEnvironmentItemId"
        :environment-id="modalEnvironmentId"
        :enable-compare-checklist="enableCompareChecklist"
        :enterprise-id="enterpriseId"
        :business-type-survey="businessTypeSurvey"
        :user-access-budget-show-price="userAccessBudgetShowPrice"
        :business-allow-edit-environment="businessAllowEditEnvironment"
        :business-evidence-file-required-fields="businessEvidenceFileRequiredFields"
        :business-evidence-file-label-order-fields="businessEvidenceFileLabelOrderFields"
        :status-checklist="statusChecklist"
        v-model="modalEnvironmentItemShow" @onClose="getList"/>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 disable-default-buttons
                 title-items="Ambientes"
                 hide-header
                 disable-footer-length
                 class="mb-5"
                 primary-key-column="checklistEnvironmentId"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <template #default>

        <t-input v-model="form.checklistEnvironmentId" hidden/>

        <b-col cols="12" class="mb-2">

          <b-row>

            <t-input cols="2" @change="executeSearchInput" v-model="form.environment" label="Ambiente"/>

            <t-input-search cols="2" @change="executeSearchInput" v-model="form.spotFolderId" select
                            :options="spotFolderOptions"
                            label="Pavimento"
                            />

            <t-input-search cols="3" @change="executeSearchInput" v-model="form.enterpriseDivisionId" select
                            :options="divisionOptions"
                            label="Divisão"
                            />

            <t-input-search cols="3" @change="executeSearchInput" v-model="form.statusEnvironment"

                            :options="StatusChecklistEnvironmentType.list"
                            label="Status Ambiente" select/>


            <t-button @click="openDialogChangeEnvironment" class="ml-3" form-inline
                      v-if="businessAllowEditEnvironment && statusChecklist === StatusChecklistType.type.PENDING">
              <b-icon-map class="mr-1" style="scale: 0.8"></b-icon-map>
              Alterar Mapeamento
            </t-button>


          </b-row>

          <t-msg info v-show="pageFormIsLoaded && listIsLoaded && items.length === 0">Nenhum ambiente encontrado de
            acordo com o filtro informado
          </t-msg>

        </b-col>

      </template>

      <template #list-content="{item}">

        <b-col cols="12">

          <b-row class="mt-1">

            <b-col cols="3" class="d-flex align-items-center link" @click="openDialogItems(item)">

              <div style="width: 30px;">


                <b-icon-check-circle-fill class="text-success" style="scale: 1.4"
                                          v-if="item.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED"/>

                <b-icon-star v-b-tooltip.hover title="Ambiente foi inspecionado na última inspeção deste empreendimento" v-else-if="item.lastSurvey === 'Y'" />

              </div>

              <!--              <div style="width: 5px; height: 100%; position: absolute; left: 0; border-radius: 3px"
                                 :class="{
                                  'bg-grey':item.statusEnvironment === StatusChecklistEnvironmentType.type.PENDING,
                                  'bg-warning':item.statusEnvironment === StatusChecklistEnvironmentType.type.STARTED,
                                  'bg-success':item.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED
                                  }"></div>-->

              <div>


                <!--
                <span class="badge badge-pill badge-light bg-light">{{ ++index }}/{{ item.qtyEnvironmentTotal }} - Cód.: {{
                    item.environmentCodeLabel
                  }}</span><br/>
                  -->

                <b-card-title class="mb-1">{{ item.environment }}</b-card-title>
                <small>{{ item.division }} - {{ item.spotFolder }}</small>

              </div>


            </b-col>

            <b-col cols="3" class="d-flex align-items-center justify-content-center link"
                   v-if="enableOccurrence"
                   @click="openDialogItems(item)">

              <b-badge v-b-tooltip.hover.ds500 title="Apontamentos finalizadas neste ambiente através deste checklist."
                       variant="success" class="mr-2">{{ item.qtyItemsOccurrencesDone }}
              </b-badge>
              <b-badge v-b-tooltip.hover.ds500
                       title="Apontamentos que já estavam pendentes neste ambiente e continuam da mesma forma."
                       variant="warning" class="mr-2">{{ item.qtyItemsOccurrencesPending }}
              </b-badge>
              <b-badge v-b-tooltip.hover.ds500 title="Apontamentos abertas neste ambiente através deste checklist."
                       variant="danger">{{ item.qtyItemsOccurrencesNew }}
              </b-badge>

            </b-col>

            <b-col cols="2" class="d-flex align-items-center justify-content-center link"
                   @click="openDialogItems(item)">

              <span v-if="item.statusEnvironment === StatusChecklistEnvironmentType.type.STARTED">
                <b-icon-clock class="mr-1" v-b-tooltip.hover.ds500 :title="getElapsedText(item.startDate,'')"/>
                {{ item.elapsedTime | minuteOrHour }}
              </span>

              <span v-else-if="item.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED">
                <b-icon-clock class="mr-1" v-b-tooltip.hover.ds500
                              :title="getElapsedText(item.startDate,item.finishDate)"/>
                {{ item.elapsedTime | minuteOrHour }}
              </span>

            </b-col>

            <b-col cols="1" class="d-flex align-items-center justify-content-center link" @click="openDialogItems(item)">

              <div v-if="item.statusEnvironment === StatusChecklistEnvironmentType.type.STARTED || item.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED" v-b-tooltip.hover title="Qtd. de fotos inseridas neste ambiente na aba 'Registro'">

                <div>
                  <b-icon-images class="mr-1"/>
                  {{ item.qtyEvidenceFile }}
                  <t-help title="Considera somente novas fotos da aba geral de inspeção do ambiente" v-if="enableOccurrence" />
                </div>

              </div>

            </b-col>

            <b-col cols="3"
                   class="d-flex align-items-center justify-content-center"
                   v-if="statusChecklist === StatusChecklistType.type.PENDING && item.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED">

              <t-button @click="confirmReverse(item.checklistEnvironmentId, item.environment)"
                        small
                        outline-danger
                        :sending="reverseFinish"
                        enable-loader
                        :title="!enableReverseFinish ? 'Perfil de acesso não habilitado para estorno de finalização' : ''"
                        :disabled="!enableReverseFinish">
                <b-icon-clipboard-x class="mr-1"></b-icon-clipboard-x>
                Estornar Ambiente
              </t-button>


            </b-col>


          </b-row>

        </b-col>

      </template>

    </t-form-list>


  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import pageListMixin from "@/mixins/page/pageListMixin";
import StatusChecklistEnvironmentType from "@/model/types/modules/checklist/StatusChecklistEnvironmentType";
import ChecklistEnvironmentItemDialog from "@/views/modules/checklist/Checklist/ChecklistEnvironmentItemDialog";
import http from "@/services/config/http-common";
import ui from "@/assets/scripts/ui";
import SpotFolderService from "@/services/modules/place/SpotFolder.service";
import StatusChecklistType from "@/model/types/modules/checklist/StatusChecklistType";
import SurveyType from "@/model/types/modules/checklist/SurveyType";
import EnterpriseDivisionService from "@/services/modules/place/EnterpriseDivision.service";
import ChecklistChangeMapDialog from "@/views/modules/place/ChecklistChangeMapDialog";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageListMixin, pageFormListMixin],
  components: {tFormList, ChecklistEnvironmentItemDialog, ChecklistChangeMapDialog},
  name: 'ChecklistEnvironment',
  data() {
    return {
      SurveyType,
      StatusChecklistType,
      StatusChecklistEnvironmentType,
      path: "checklist/environment", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "checklistId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "checklistEnvironmentId", keyDelete: "checklistEnvironmentId"},
        {key: "environmentId", label: "Cód. Amb.", cols: "3"},
        {key: "environment", label: "Ambiente", cols: "3"},
        {key: "resume", label: "Resumo", cols: "4"},
      ],
      form: {
        checklistId: this.foreignKey,
        checklistEnvironmentId: 0,
        environment: "",
        statusEnvironment: 0,
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        code: "",
      },
      accountModule: "",
      reverseFinish: false,
      modalEnvironmentItemId: 0,
      modalEnvironmentId: 0,
      modalEnvironmentItemShow: false,
      modalChangeMapShow: false,
      request: {},
      divisionOptions: [],
      spotFolderOptions: [],

    }
  },
  props: {
    userAccessBudgetShowPrice: {
      type: Boolean,
      default: false,
    },
    enableCompareChecklist: Boolean,
    enableOccurrence: Boolean,
    businessAllowEditEnvironment: Boolean,
    businessTypeSurvey: Number,
    businessEvidenceFileRequiredFields: String,
    businessEvidenceFileLabelOrderFields: String,
    enterpriseId: Number,
    statusChecklist: Number,
    enableReverseFinish: Boolean,
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      //Padrão neste caso deste tipo de relação, sendo fixo esta informação
      this.form.typeRelation = 1

    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

      this.accountModule = ui.getAccountModule()

    },

    async mountedContinued() {

      await this.getList()

      await SpotFolderService.selectListGroupedByEnterpriseId(this.enterpriseId).then(list => this.spotFolderOptions = list)

      await EnterpriseDivisionService.selectList(this.enterpriseId).then((list) => {
        this.divisionOptions = list
      }).catch(error => this.responseError(error))


    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.checklistEnvironmentId)

    },

    mountedList() {

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    getElapsedText(startDate, finishDate) {

      if (startDate !== '' && finishDate !== '') {
        return 'Iniciado em: ' + ui.convertDateBR(startDate, true) + ' - finalizado em: ' + ui.convertDateBR(finishDate, true)
      } else {
        return 'Iniciado em: ' + ui.convertDateBR(startDate, true)
      }

    },

    openDialogChangeEnvironment() {

      if (this.businessAllowEditEnvironment) {
        this.modalChangeMapShow = true
        this.openModal('modal-checklist-change-map-dialog')
      } else {
        ui.msg(this, 'Você não possui acesso a alteração de mapeamento na inspeção')
      }

    },

    async executeSearchInput() {

      this.listIsLoaded = false

      setTimeout(async () => {
        await this.executeSearch(false, false)
        this.listParams = this.searchParams
      }, 100)


    },
    afterGetPage() {

      this.items = this.request
      this.listIsLoaded = true

    },
    async openDialogItems(item) {

      if (item.statusEnvironment === StatusChecklistEnvironmentType.type.PENDING && this.statusChecklist === StatusChecklistType.type.PENDING) {
        await this.actionEnvironment(item, 'started')
        this.modalEnvironmentItemShow = true
        this.modalEnvironmentItemId = item.checklistEnvironmentId
        this.modalEnvironmentId = item.environmentId

      } else {
        this.modalEnvironmentItemShow = true
        this.modalEnvironmentItemId = item.checklistEnvironmentId
        this.modalEnvironmentId = item.environmentId
      }

    },
    async actionEnvironment(item, intent) {

      let action = 0;

      /* action: 1 = Iniciar, 2 = Finalizar ambiente*/
      if (intent === 'started') {
        action = 1
      } else {
        action = 2
      }

      const data = {
        checklistEnvironmentId: item.checklistEnvironmentId,
        action,
      }

      if (action === 2) {

        /*  await http.get(this.path + "/checkIsFinished/" + item.checklistEnvironmentId).then(async () => {

            ui.msgConfirm(this, '', 'Tem certeza que deseja finalizar a inspeção deste ambiente:<br /><b>' + item.environment + '</b>', async () => {

              console.log(this.form)

              /!*await http.post(this.path + "/action", data).then(async () => {
                await this.getList()
              }).catch(error => ui.generalResponseError(this, error))*!/
            }, 'Finalizar')

          }).catch(error => ui.generalResponseError(this, error))*/

      } else {

        await http.post(this.path + "/action", data).then(async () => {
          await this.getList()
        }).catch(error => ui.generalResponseError(error))

      }

    },

    async confirmReverse(checklistEnvironmentId, environment) {

      ui.msgConfirm(this, 'ESTORNO DA FINALIZAÇÃO DO AMBIENTE', '<span class="text-danger">Tem certeza que deseja realizar o estorno da finalização desta Ambiente <b>' + environment + '</b>?<br /><br />Todos os processos relacionados a este ambiente serão estornados.', async () => {

        this.reverseFinish = true

        await http.get(this.path + "/reverse-finish/" + checklistEnvironmentId).then(async () => {

          ui.toast(this, 'Sucesso', "Estorno no ambiente realizado com sucesso!")
          await this.getList()

        }).catch(error => ui.generalResponseError(this, error))

        this.reverseFinish = false

      })

    },

    getListEnvironment() {


    },

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
